<template>
  <div>
    <search-list @postParams="findData" :categoryList="categoryList"></search-list>
    <div class="page-wrapper">
    <table-list
      
      :columns="columns"
      :data="data"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
      <Button type="primary" class="btn" @click="changeKey" v-p="{api:'supplier/add'}">添加供应商</Button>
    </table-list>
    </div>
    <add-suppliers-modal :n="key" @refresh="refreshTabel" :categoryList="categoryList"></add-suppliers-modal>
    <update-suppliers-modal :n="key2" :categoryList="categoryList" @refresh="refreshTabel"
                            :suppliersData="suppliersData"></update-suppliers-modal>
  </div>

</template>

<script type="text/ecmascript-6">
  import {goodsInfoMenu} from "api/goods";
  import {getList, addSupplier} from "api/supplier";
  import SearchList from './components/SearchList';
  import TableList from 'components/TableList/index';
  import AddSuppliersModal from './components/AddSuppliersModal';
  import UpdateSuppliersModal from './components/UpdateSuppliersModal'

  export default {
    name: 'suppliers',
    components: {
      SearchList,
      TableList,
      AddSuppliersModal,
      UpdateSuppliersModal
    },
    created() {
      this.initData(this.params)
    },
    data() {
      return {
        suppliersData: {
          code: '',
          supplierName: '',
          brand: '',
          categoryName: [],
          manager: '',
          contactPhone: '',
          fid: ''
        },
        key2: 0,
        key: 0,
        total: 0,
        current: 1,
        loading: true,
        params: {
          page: 1,
          limit: 10
        },
        columns: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '供应商名称',
            align: 'center',
            key: 'supplierName'
          },
          {
            title: '品牌',
            align: 'center',
            key: 'brand'
          },
          {
            title: '供应商编码',
            align: 'center',
            key: 'code'
          },
          {
            title: '供应类目',
            align: 'center',
            key: 'categoryName'
          },
          {
            title: '负责人',
            align: 'center',
            key: 'manager'
          },
          {
            title: '联系方式',
            align: 'center',
            key: 'contactPhone'
          },
          {
            title: '创建日期',
            align: 'center',
            key: 'createTime'
          },
          {
            title: '创建人',
            align: 'center',
            key: 'createName'
          },
          {
            title: '操作',
            align: 'center',
            key: 'action',
            render: (h, params) => {
              return h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'supplier/update'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.clickUpdate(params.row)
                  }
                }
              }, '修改')
            }

          }
        ],
        data: [],
        categoryList: [],
      }
    },
    computed: {
      categoryMap() {
        var ret = {}

        function map(array) {
          array.forEach((ele) => {
            ret[ele.text] = ele.value
            ele.children && map(ele.children)
          })
        }

        map(this.categoryList)
        return ret
      }
    },
    methods: {
      clickUpdate(param) {
        // console.log(param)


        let category = param.categoryName.split(',')

        this.suppliersData.code=param.code
        this.suppliersData.supplierName=param.supplierName
        this.suppliersData.brand=param.brand
        this.suppliersData.manager=param.manager
        this.suppliersData.contactPhone=param.contactPhone
        this.suppliersData.fid=param.fid
        this.suppliersData.categoryName = category

        this.key2++
      },
      changeKey() {
        this.key++
      },
      initData(params) {
        getList(params).then(res => {
          this.data = res.data.rows;
          this.total = res.data.total;
        })
        goodsInfoMenu().then(res => {
          this.categoryList = res.data
          this.loading = false
        })
      },
      changPage(n) {
        this.current = n
        this.params.page = n
        this.initData(this.params)
      },
      refreshTabel() {
        this.initData()
      },
      findData(params) {
        this.current = 1;
        delete params.categoryValue
        getList(params).then(res => {
          this.data = res.data.rows;
          this.total = res.data.total;
        })
      }
    }
  }
</script>

<style lang="css" scoped>
  .btn {
    margin-bottom: 20px;
  }
</style>
